// Mirrors the Happy Hour site's closing "Find a Location" band.
.section {
    padding: 64px 0;

    @media (min-width: 1024px) {
        padding: 80px 0;
    }
}

// Balanced like the microsite's "Find a Location Near You".
.heading {
    text-wrap: balance;
}

.cta {
    margin-top: 32px;

    @media (min-width: 1024px) {
        margin-top: 40px;
    }
}
